<template>
  <div v-if="!isLoading">
    <div v-if="1 == 2">
      {{ formData }}
    </div>

    <vs-card>
      <!-- Botão voltar -->
      <div class="lg:block">
        <vs-button @click="voltar" type="border">Voltar</vs-button>
      </div>

      <CadastroTerceiroForm :formData="formData" :dominios="dominios" />

      <DadosTerceiroForm :formData="formData" :dominios="dominios" />

      <DadosVeiculoTerceiroForm :formData="formData" />

      <ReparoVeiculoDetalhesForm
        :formData="formData"
        :dominios="dominios"
        :terceiro="true"
      />

      <FotosDocumentos
        :formData="formData"
        :arquivos="formData.arquivosTerceiros"
        :idReferente="idReferenteEvento"
      />

      <CustoEventoTerceiroForm :formData="formData" />

      <ProcessoDatasForm :formData="formData" :dominios="dominios" />
    </vs-card>

    <!-- Botões Voltar e Salvar -->
    <div class="flex lg:justify-between justify-end">
      <div class="lg:block">
        <vs-button @click="voltar">Voltar</vs-button>
      </div>

      <vs-button color="success" @click="submit()">
        Salvar Alterações
      </vs-button>
    </div>
  </div>
</template>

<script>
import eventoService from './../shared/service';
import notify from './../../../../utils/notify';
import service from './../../../../services';
import utilsLocal from './../utils';

import { FOTO_REFERENTE_TERCEIROS } from './../shared/const';

// Component
import CadastroTerceiroForm from './components/CadastroTerceiroForm.vue';
import DadosTerceiroForm from './../shared/components/DadosTerceiroForm.vue';
import DadosVeiculoTerceiroForm from './components/DadosVeiculoTerceiroForm.vue';
import ReparoVeiculoDetalhesForm from './../shared/components/ReparoVeiculoDetalhesForm.vue';
import FotosDocumentos from './../shared/components/FotosDocumentos.vue';
import CustoEventoTerceiroForm from './components/CustoEventoTerceiroForm.vue';
import ProcessoDatasForm from './../shared/components/ProcessoDatasForm.vue';

export default {
  components: {
    CadastroTerceiroForm,
    DadosTerceiroForm,
    DadosVeiculoTerceiroForm,
    ReparoVeiculoDetalhesForm,
    FotosDocumentos,
    CustoEventoTerceiroForm,
    ProcessoDatasForm,
  },
  data() {
    return {
      isLoading: true,
      idReferenteEvento: FOTO_REFERENTE_TERCEIROS,

      // Domínios
      dominios: {
        listEnvolvimentos: [],
        listMotivos: [],
        listSituacoes: [],
        listLocalizacaoDocumentos: [],
        listGeneros: [
          { id: 1, label: 'Masculino' },
          { id: 2, label: 'Feminino' },
          { id: 3, label: 'Outro' },
        ],
        listResponsaveis: []
      },

      // Formulário
      formData: {
        cadastroTerceiro: {},
        dadosTerceiro: {},
        dadosVeiculoTerceiro: {},
        reparoVeiculo: {},
        custoEvento: {},
        processosDatas: {},
        arquivosTerceiros: [],
      },
    };
  },
  methods: {
    voltar() {
      this.$router.go(-1);
    },
    async getListDominios() {
      try {
        this.$vs.loading();

        const promises = [
          eventoService.getListDominio(
            'domEventosEnvolvimentos',
            'envolvimento',
            'idEnvolvimento',
          ),
          utilsLocal.bucarMotivos(),
          utilsLocal.bucarSituacoes(),
          eventoService.getListDominio('domTipoFipe', 'nomeTipo', 'idTipoFipe'),
          eventoService.getListDominio('domUf', 'nomeUf', 'codUf'),
          eventoService.getListUsuarios(),
          eventoService.getListVistoriadores(),
          eventoService.getListLocalizacaoDocumentacao(),
          eventoService.getListOficinas(),
        ];

        const [
          listEnvolvimentos,
          listMotivos,
          listSituacoes,
          listTiposVeiculo,
          listEstados,
          listResponsaveis,
          listVistoriadores,
          listLocalizacaoDocumentos,
          listOficinas,
        ] = await Promise.all(promises);

        listMotivos.forEach((element) => {
          this.dominios.listMotivos.push({
            id: element.idMotivo,
            label: element.nomeMotivo,
          });
        });

        listSituacoes.forEach((element) => {
          this.dominios.listSituacoes.push({
            id: element.idStatus,
            label: element.nomeStatus,
          });
        });

        this.dominios.listEnvolvimentos = listEnvolvimentos;
        this.dominios.listTiposVeiculo = listTiposVeiculo;
        this.dominios.listEstados = listEstados;
        this.dominios.listResponsaveis = listResponsaveis;
        this.dominios.listVistoriadores = listVistoriadores;
        this.dominios.listLocalizacaoDocumentos = listLocalizacaoDocumentos;
        this.dominios.listOficinas = listOficinas;
      } catch (error) {
        notify.notifyFail(this.$vs, error);
      } finally {
        this.$vs.loading.close();
      }
    },
    async getTerceiro() {
      const { idTerceiro } = this.$route.params;

      if (!idTerceiro) {
        return;
      }

      try {
        this.$vs.loading();

        const result = await service.getAll(
          'eventos-terceiros',
          null,
          idTerceiro,
        );
        const terceiro = result.data;

        if (!terceiro) {
          notify.notifyFail(
            this.$vs,
            'Você não tem acesso a visualização deste Terceiro',
          );
          this.$vs.loading.close();
          return;
        }

        this.isLoading = false;

        this.$nextTick(() => {
          this.formData = terceiro;
        });
      } catch (error) {
        notify.notifyFail(this.$vs, error);
      } finally {
        this.$vs.loading.close();
      }
    },
    async submit() {
      try {
        this.$vs.loading();

        const idUsuarioSend = eventoService.getIdUsuario();
        const data = { ...this.formData, idUsuarioSend };

        const dataTerceiro = await service.post(
          'eventos-terceiros',
          'update',
          data,
        );

        this.formData = dataTerceiro.data;
        notify.notifySuccess(this.$vs, 'Terceiro salvo com sucesso!');
      } catch (error) {
        notify.notifyFail(this.$vs, error);
      } finally {
        this.$vs.loading.close();
      }
    },
  },
  async mounted() {
    await this.getListDominios();
    await this.getTerceiro();
  },
};
</script>
